// Character mapping from Unicode to ASCII equivalents
export const characterMapping: Record<string, string> = {
	'\u0009': '    ',   // TAB → 4 spaces
	'\u2018': "'",      // ‘ LEFT SINGLE QUOTATION MARK
	'\u2019': "'",      // ’ RIGHT SINGLE QUOTATION MARK
	'\u201C': '"',      // “ LEFT DOUBLE QUOTATION MARK
	'\u201D': '"',      // ” RIGHT DOUBLE QUOTATION MARK
	'\u2013': '-',      // – EN DASH
	'\u2014': '-',      // — EM DASH
	'\u2026': '...',    // … HORIZONTAL ELLIPSIS
	'\u00A0': ' ',      // NO-BREAK SPACE
	'\u00BD': '1/2',    // ½ VULGAR FRACTION ONE HALF
	'\u00BC': '1/4',    // ¼ VULGAR FRACTION ONE QUARTER
	'\u00BE': '3/4',    // ¾ VULGAR FRACTION THREE QUARTERS
	'\u00B0': '-',      // ° DEGREE SIGN
	'\u2022': '-',      // • BULLET
	'\u20AC': 'EUR',    // € EURO SIGN
	'\u00A3': 'GBP'     // £ POUND SIGN
  }
  
  // Main sanitization function
  export function sanitizeInput(
	input: string
  ): { sanitized: string; mapped: boolean; ignored: boolean } {
	let mapped = false
	let ignored = false
  
	const sanitized = Array.from(input).map((char) => {
	  const code = char.charCodeAt(0)
	  // Support: CR (13), LF (10), and ASCII printable (32-126)
	  if (code === 10 || code === 13 || (code >= 32 && code <= 126)) return char // Keep valid characters
	  if (characterMapping[char]) {
		mapped = true
		return characterMapping[char]
	  }
	  ignored = true
	  return '' // Remove unsupported char
	}).join('')
  
	return { sanitized, mapped, ignored }
  }
  